export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-queue/src/array.js
// module id = ../../../../d3-queue/src/array.js
// module chunks = vendor